module.exports = __webpack_public_path__ + "img/2-ilpakamanicalletemuco.cc8794c7.jpg";